import React from "react";
import { SupText } from "@repo/core-ui";
import CountUp from "react-countup";
import { twMerge } from "tailwind-merge";

interface ProtocolCardProps {
  value: number;
  subtitle: string;
  className?: string;
  isLoading?: boolean;
}

export function ProtocolCard({ value, subtitle, className, isLoading }: ProtocolCardProps) {
  return (
    <div className={twMerge("flex items-center justify-between rounded-3xl rounded-tr-none border-[0.5px] border-primary-400 px-3 py-5", className)}>
      <div className="space-y-2">
        {isLoading ? (
          <>
            <div className="h-8 w-24 animate-pulse rounded-md bg-neutral-200" />
            <div className="h-4 w-32 animate-pulse rounded-md bg-neutral-200" />
          </>
        ) : (
          <>
            <SupText className="text-3xl leading-none text-neutral-950" variant="body1" family="mono" weight="bold">
              <CountUp start={0} duration={2} end={value} />
            </SupText>
            <SupText className="uppercase text-neutral-950" variant="body1" family="mono" weight="regular">
              {subtitle}
            </SupText>
          </>
        )}
      </div>
    </div>
  );
}
